// extracted by mini-css-extract-plugin
export default {"remain_credits":"remain-credits_remain_credits__pi7Ef","credits_img":"remain-credits_credits_img__Z7oHG","credits":"remain-credits_credits__205Td"};